import axios from "axios";
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
export const userPlanList = async (accessToken) => {
    try {
      const response = await axiosInstance.get("/business/plans/list", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status == 403) {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
        throw {
          statusCode: status,
          message:
            error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
        };
      } else {
        throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
      }
    }
  };